import { createRef, useEffect } from 'react';

/**
 * Scrolls Into View the element that receives the returned ref from the hook
 * @param topic - unique string, ref should be only assigned to the element that has this string
 * @returns {React.RefObject<unknown>}
 */
export default (topic) => {
  const ref = createRef();
  useEffect(() => {
    if (ref.current) ref.current.scrollIntoView({ behavior: 'smooth' });
  }, [topic, ref.current]);
  return ref;
};
